import gql from 'graphql-tag';

export const createEscalationRule = gql`
  mutation createEscalationRule($escalationRule: InputCreateEscalationRule!) {
    createEscalationRule(escalationRule: $escalationRule)
  }
`;
